import { render, staticRenderFns } from "./tools-tab.vue?vue&type=template&id=4c0f1962&scoped=true"
import script from "./tools-tab.vue?vue&type=script&lang=js"
export * from "./tools-tab.vue?vue&type=script&lang=js"
import style0 from "./tools-tab.vue?vue&type=style&index=0&id=4c0f1962&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0f1962",
  null
  
)

export default component.exports